// noinspection JSUnusedGlobalSymbols

import _ from 'lodash';

import {Audit, DbModel, type IAudit} from './db.model';
import {AuditTypes, DocTypes, DocPrefix} from "../constants";

export interface IDevice {
  did?: string;
  uid?: string;
  info: DeviceInfo | IFingerPrint;
  location: object;
  network: object;
  contacts?: Array<object>;
}

export class Device extends DbModel implements IDevice {
  did?: string;
  uid?: string;
  info: DeviceInfo | IFingerPrint;
  location: object;
  network: object;
  contacts?: Array<object>;

  constructor(private data?: IDevice) {
    super();

    const id = _.get(this.data, '_id', DocPrefix.consents + _.shortID(DocTypes.consents));
    this._id = _.get(this.data, '_id', id);
    this.type = DocTypes.device;
    this.did = _.get(this.data, 'did', id);
    this.uid = _.get(this.data, 'uid', null);
    this.info = (_.isString(this.data.info) ? JSON.parse(_.get(this.data, 'info', null)) : this.data.info);
    this.network = (_.isString(this.data.network) ? JSON.parse(_.get(this.data, 'network', null)) : this.data.network);
    this.location = (_.isString(this.data.location) ? JSON.parse(_.get(this.data, 'location', null)) : this.data.location);
    this.contacts = (_.isString(this.data.contacts) ? JSON.parse(_.get(this.data, 'contacts', null)) : this.data.contacts);
    this.audit = (_.omitBy(new Audit(_.merge(this.data, {did: this.did}), AuditTypes.created), _.isNil) as IAudit);
  }
}

export interface IFingerPrint {
  uuid: string;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  browser: string;
  os: string;
  platform: string;
  fingerprint: object;
}

export declare type OperatingSystem = 'ios' | 'android' | 'windows' | 'mac' | 'unknown';
export interface DeviceInfo {
  name?: string;
  model: string;
  platform: 'ios' | 'android' | 'electron' | 'web';
  uuid: string;
  appVersion: string;
  appBuild: string;
  appId: string;
  appName: string;
  operatingSystem: OperatingSystem;
  osVersion: string;
  manufacturer: string;
  isVirtual: boolean;
  memUsed?: number;
  diskFree?: number;
  diskTotal?: number;
}

export interface IDevicePayload {
  info: DeviceInfo | IFingerPrint;
  location: object;
  network: object;
}

